import { render, staticRenderFns } from "./AllEscalations.vue?vue&type=template&id=06e791ba&"
import script from "./AllEscalations.vue?vue&type=script&lang=ts&"
export * from "./AllEscalations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports